/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // function setHeaderHeight() {
  //   var slideHeight = 0;
  //   if($(".homepage-slideshow").length > 0){
  //     slideHeight = $(".homepage-slideshow").height();
  //   }else if($(".index-hero").length > 0){
  //     slideHeight = $(".index-hero").height();
  //   }
  //   if(slideHeight > 0){
  //     $(".main-nav").css({height: slideHeight + "px"});
  //   }
  // }
  function setHeaderHeight() {
    var slideHeight = 0;
    if (document.querySelectorAll(".shopify-section:first-child .homepage-slideshow").length > 0) {
      slideHeight = document.querySelector(".shopify-section:first-child .homepage-slideshow").offsetHeight;
      console.log(slideHeight);
    } else if (document.querySelectorAll(".shopify-section:first-child .index-hero").length > 0) {
      slideHeight = document.querySelector(".shopify-section:first-child .index-hero").offsetHeight;
      console.log(slideHeight);
    }
    if (slideHeight > 0) {
      document.querySelector(".main-nav").style.height = slideHeight + "px";
    }
  }
  
  setHeaderHeight();

  window.onresize = function(event) {
      setHeaderHeight();
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
